module.exports = __webpack_public_path__ + "img/product13-juece.2ac86d77.svg";